import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Back, gsap } from "gsap";
import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4"; // Import GA4
import cvEvent from "../pdf/Yannis_Fouzi_CV_2026-2.pdf";
import cvDev from "../pdf/YannisFouzi-CV2026-Avril.pdf";
import "./Header.css";

function Header() {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const title = document.querySelector(".title");
    // Sécurisation : utilisation de textContent pour éviter l'injection
    const text = title.textContent;
    title.textContent = ""; // Vider le contenu

    // Créer les spans de manière sécurisée
    text.split("").forEach((char) => {
      if (char.trim()) {
        // Ignorer les espaces
        const span = document.createElement("span");
        span.textContent = char; // Utiliser textContent au lieu d'innerHTML
        title.appendChild(span);
      } else {
        title.appendChild(document.createTextNode(char));
      }
    });

    // Animation : les lettres apparaissent par le bas
    gsap.fromTo(
      ".title span",
      { opacity: 0, bottom: -80 },
      {
        opacity: 1,
        bottom: 0,
        ease: Back.easeOut.config(1.7),
        stagger: 0.05,
        duration: 0.5,
      }
    );
  }, []);

  const handleCVDevClick = () => {
    ReactGA.event({
      category: "CV",
      action: "Download",
      label: "CV Développeur",
    });
  };

  const handleCVEventClick = () => {
    ReactGA.event({
      category: "CV",
      action: "Download",
      label: "CV Événementiel",
    });
  };

  const handleCopy = () => {
    navigator.clipboard.writeText("contact@fouzi-dev.fr").then(() => {
      ReactGA.event({
        category: "Email",
        action: "Copy",
        label: "User clicked to copy email",
      });

      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    });
  };

  return (
    <header>
      <div className="container">
        <h1>
          <span className="title">Yannis Fouzi</span>
        </h1>
        <div className="header-roles">
          <div className="role">
            <h2>Créateur de solutions numériques</h2>
            <p>Web · Automatisation · Infrastructure</p>
            <a href={cvDev} download className="link-github cv-btn" onClick={handleCVDevClick}>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32 32"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z"></path>
                </svg>
              </span>
            Téléchargez CV Développeur
          </a>
          </div>
          <div className="role">
            <h2>Organisateur d'événements</h2>
            <p>Audiovisuel · Communication · Animation</p>
            <a href={cvEvent} download className="link-github cv-btn" onClick={handleCVEventClick}>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32 32"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z"></path>
                </svg>
              </span>
              Téléchargez CV Événementiel
            </a>
          </div>
        </div>
        <div className="header-email">
          <button className="link-github email-btn" type="button" onClick={handleCopy}>
            <span>
              <FontAwesomeIcon icon={faEnvelope} />
            </span>
            {copied ? "Email copié !" : "Copiez mon email"}
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
